import createModal from '@/components/common/create-modal';
import SocialPasswordModal from './social-password-modal';

export const {
  open,
  hide,
} = createModal('steamup-social-password-modal', SocialPasswordModal, { zIndex: 1000 });

interface OpenSocialLoginModalProps {
  onSuccess?: () => void;
  onClose?: () => void;
}

export const openSocialPwModal = (props: OpenSocialLoginModalProps = {}) => {
  open(props);
};

export const hideSocialPwModal = () => {
  hide();
};
